export const GET_TEMPLATE_WATCHER =
  "app/MeasurementImportRecipients/GET_TEMPLATE_WATCHER"
export const GET_TEMPLATE_FAILED =
  "app/MeasurementImportRecipients/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS =
  "app/MeasurementImportRecipients/GET_TEMPLATE_SUCCESS"

export const UPLOAD_TEMPLATE_WATCHER =
  "app/MeasurementImportRecipients/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS =
  "app/MeasurementImportRecipients/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED =
  "app/MeasurementImportRecipients/UPLOAD_TEMPLATE_FAILED"
